import { takeLatest, takeEvery } from 'redux-saga/effects';
import { EventsActionType } from '../types/eventsTypes';
import {
  fetchEventsSaga,
  fetchEventDetailsSaga,
  fetchEventTitlesSaga,
  fetchEventSessionsSaga,
  fetchSessionDetailsSaga,
  fetchEventPropertiesSaga,
} from './eventsSaga';

export function* eventsWatchers() {
  yield takeLatest(EventsActionType.FETCH_EVENTS, fetchEventsSaga);
  yield takeLatest(EventsActionType.FETCH_EVENT_PROPERTIES, fetchEventPropertiesSaga);
  yield takeEvery(EventsActionType.FETCH_EVENT_DETAILS, fetchEventDetailsSaga);
  yield takeLatest(EventsActionType.FETCH_EVENT_TITLES, fetchEventTitlesSaga);
  yield takeLatest(EventsActionType.FETCH_EVENT_SESSIONS, fetchEventSessionsSaga);
  yield takeLatest(EventsActionType.FETCH_SESSION_DETAILS, fetchSessionDetailsSaga);
  yield takeLatest(EventsActionType.SET_EVENTS_CATEGORY_FILTER, fetchEventsSaga);
  yield takeLatest(EventsActionType.SET_EVENTS_TIMELINE_FILTER, fetchEventsSaga);
  yield takeLatest(EventsActionType.SET_EVENTS_FAVORITES_FILTER, fetchEventsSaga);
  yield takeLatest(EventsActionType.SET_EVENTS_SORT_DESC, fetchEventsSaga);
}
